const app_state = window.hasOwnProperty('app_state') ? window.app_state : {};

export {
    app_state
}
